import { render, staticRenderFns } from "./servingSize.vue?vue&type=template&id=4d16cca3&scoped=true"
import script from "./servingSize.vue?vue&type=script&lang=js"
export * from "./servingSize.vue?vue&type=script&lang=js"
import style0 from "./servingSize.vue?vue&type=style&index=0&id=4d16cca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16cca3",
  null
  
)

export default component.exports